/* Estructura de precios por concepto (todos los campos opcionales)
   Internos: CD M.O., CD Materiales, CD Total (auto o manual), Utilidades
   Cliente:  PU Solo M.O., PU Con Material */

export const numOrNull = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

// CD Total: si hay desglose (M.O. y/o Materiales) se calcula; si no, se usa el manual
export const cdTotalIsAuto = (c) => numOrNull(c.cd_mo) !== null || numOrNull(c.cd_materiales) !== null;

export const cdTotal = (c) => {
  if (!cdTotalIsAuto(c)) return numOrNull(c.cd_total_manual);
  return (numOrNull(c.cd_mo) || 0) + (numOrNull(c.cd_materiales) || 0);
};

// Utilidad Solo M.O. = PU Solo M.O. − CD M.O.
export const utilidadMo = (c) => {
  const pu = numOrNull(c.pu_mo);
  const mo = numOrNull(c.cd_mo);
  if (pu === null || mo === null) return null;
  return pu - mo;
};

// Utilidad Con Material = PU Con Material − CD Materiales − CD M.O. (= PU − CD Total)
export const utilidadConMaterial = (c) => {
  const pu = numOrNull(c.pu_con_material);
  const cd = cdTotal(c);
  if (pu === null || cd === null) return null;
  return pu - cd;
};

export const margenPct = (utilidad, pu) => (utilidad === null || !pu ? null : (utilidad / pu) * 100);

/* Precios que se muestran al cliente. Compatibilidad: si el concepto no tiene
   ninguno de los dos PU nuevos, se usa el precio_unitario base como "Con Material". */
export const clientPrices = (c) => {
  const puMo = numOrNull(c.pu_mo);
  let puMat = numOrNull(c.pu_con_material);
  if (puMo === null && puMat === null) {
    const base = numOrNull(c.precio_unitario);
    puMat = base && base > 0 ? base : null;
  }
  return { puMo, puMat };
};
